@if (url()) {
  <img class="object-cover w-full h-full" [src]="url()" alt="">
} @else {
  <div class="avatar" [ngStyle]="{'background-color': backgroundColor() }">
    <span>{{ initials() }}</span>
  </div>
}
